import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AuthUser } from '../../../core/interfaces/auth/phone-auth.interface';
import { AuthActions } from './auth.actions';

export interface AuthStateModel {
  user: AuthUser | null;
  isAuthenticated: boolean;
}

const defaults: AuthStateModel = {
  user: null,
  isAuthenticated: false
};

@State<AuthStateModel>({
  name: 'auth',
  defaults
})
@Injectable()
export class AuthState {
  @Selector()
  static user(state: AuthStateModel): AuthUser | null {
    return state.user;
  }

  @Selector()
  static isAuthenticated(state: AuthStateModel): boolean {
    return state.isAuthenticated;
  }

  @Selector()
  static token(state: AuthStateModel): string | null {
    return state.user?.token || null;
  }

  @Action(AuthActions.SetUser)
  setUser(
    ctx: StateContext<AuthStateModel>,
    { payload }: AuthActions.SetUser
  ): void {
    ctx.patchState({
      user: payload,
      isAuthenticated: !!payload.token
    });
  }

  @Action(AuthActions.SetToken)
  setToken(
    ctx: StateContext<AuthStateModel>,
    { token }: AuthActions.SetToken
  ): void {
    const state = ctx.getState();
    const updatedUser: AuthUser = {
      ...(state.user || { email: '', displayName: '', nicename: '' }),
      token
    };
    ctx.patchState({
      user: updatedUser,
      isAuthenticated: !!token
    });
  }

  @Action(AuthActions.ClearUser)
  clearUser(ctx: StateContext<AuthStateModel>): void {
    ctx.setState(defaults);
  }
}
